'use client';

import { useGtmTrack } from '../index';
import { ANALYTICS_EVENTS } from '../types';
import type { TrackingFunction } from '../types';

export const useFloatingDisclaimerShownTracking = (props = {}, autoTrack: boolean = false): TrackingFunction => {
  return useGtmTrack(
    {
      eventName: ANALYTICS_EVENTS.FLOATING_DISCLAIMER_SHOWN,
      properties: props,
    },
    autoTrack,
  );
};
